var _circle, _circle2, _circle3, _circle4, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStartEnd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 78,
    viewBox: "0 0 16 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.76001,
    cy: 6,
    r: 5,
    stroke: "#0B487B",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.76001,
    cy: 22,
    r: 2,
    fill: "#0B487B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.76001,
    cy: 34,
    r: 2,
    fill: "#0B487B"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.76001,
    cy: 46,
    r: 2,
    fill: "#0B487B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.76008 56C3.48111 56 0 59.4811 0 63.7601C0 68.9689 7.11468 77.4808 7.41762 77.8406C7.5022 77.9412 7.62678 77.9994 7.75817 78C7.75882 78 7.75942 78 7.76008 78C7.89075 78 8.01503 77.9429 8.10009 77.8435C8.40303 77.4898 15.5202 69.1185 15.5202 63.7601C15.5201 59.4811 12.039 56 7.76008 56ZM7.76276 76.8478C6.3339 75.0707 0.895394 68.0253 0.895394 63.7601C0.895394 59.9749 3.97489 56.8954 7.76008 56.8954C11.5453 56.8954 14.6248 59.9749 14.6248 63.7601C14.6247 68.1469 9.19569 75.0915 7.76276 76.8478Z",
    fill: "#E87436"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7601 60.3154C5.9409 60.3154 4.46094 61.7953 4.46094 63.6145C4.46094 65.4337 5.9409 66.9137 7.7601 66.9137C9.57931 66.9137 11.0593 65.4337 11.0593 63.6145C11.0593 61.7953 9.57931 60.3154 7.7601 60.3154ZM7.7601 66.0182C6.43468 66.0182 5.35633 64.94 5.35633 63.6145C5.35633 62.289 6.43462 61.2107 7.7601 61.2107C9.08559 61.2107 10.1639 62.289 10.1639 63.6145C10.1639 64.94 9.08547 66.0182 7.7601 66.0182Z",
    fill: "#E87436"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartEnd);
export default __webpack_public_path__ + "static/media/start-end.c86af372ccd2ba7829f741783b399bf5.svg";
export { ForwardRef as ReactComponent };